export default __webpack_public_path__ + "static/media/error.6dd1b8ae.svg";